const Vr13 = () => {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-13/PNG%20n.4/3d%20%2013-4/publish%2013-4/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 13 Tour"
        ></iframe>
      </div>
    );
};

export default Vr13;
